import { render, staticRenderFns } from "./TeamManager.vue?vue&type=template&id=36c39e09&"
import script from "./TeamManager.vue?vue&type=script&lang=js&"
export * from "./TeamManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports